<template>
  <div class="sp-index__calendar">
    <div class="sp-index__calendar-left">
      <el-calendar v-model="valueTime">
        <template slot="dateCell" slot-scope="{ date, data }">
          <div :class="['sp-index__calendar-item', getDateClass(data)]" @click="showEditDialog(data)">
            {{ formatDate(data.day) }}
            <span v-if="isSpecialStatus('holiday-rest', data)">
              {{ getSpecialStatusLabel('holiday-rest', data) }}
            </span>
            <span v-if="isSpecialStatus('holiday-work', data)">
              {{ getSpecialStatusLabel('holiday-work', data) }}
            </span>
            <small v-if="isSpecialStatus('adjustment', data)" class="sp-index__calendar-work">
              班
            </small>
            <small v-if="isSpecialStatus(['holiday-rest', 'rest', 'weekend'], data)" class="sp-index__calendar-reset">
              休
            </small>
          </div>
        </template>
      </el-calendar>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog :visible.sync="dialogVisible" title="编辑日期状态" width="30%">
      <el-form :model="selectedDate" label-width="100px" v-if="dialogVisible">
        <el-form-item label="日期">
          <el-input v-model="selectedDate.formattedDay" disabled></el-input>
        </el-form-item>
        <el-form-item label="节日名称">
          <el-input v-model="selectedDate.holidayName"></el-input>
        </el-form-item>
        <el-form-item label="是否为节假日">
          <el-radio-group v-model="selectedDate.status">
            <el-radio label="rest">休息</el-radio>
            <el-radio label="adjustment">调休</el-radio>
            <el-radio label="holiday-rest">节假日休息</el-radio>
            <el-radio label="holiday-work">节假日上班</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要调休">
          <el-checkbox v-model="selectedDate.adjustment">需要调休</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="danger" @click="delDateStatus(selectedDate.id)" v-if="selectedDate.id">删除</el-button>
        <el-button type="primary" @click="saveDateStatus">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const enumApis = {
      get: '/system/configurationCalendar/list?pageSize=365',
      add: '/system/configurationCalendar/add',
      del: '/system/configurationCalendar/del'
    }
    return {
      enumApis,
      valueTime: new Date(),
      specialDates: [],
      dialogVisible: false,
      selectedDate: {
        id: undefined,
        holidayName: '',
        day: '',
        formattedDay: '',
        status: 'work',
        adjustment: false
      }
    };
  },
  watch: {
    valueTime(newVal, oldVal) {
      if (newVal.getMonth() !== oldVal.getMonth() || newVal.getFullYear() !== oldVal.getFullYear()) {
        this.fetchSpecialDates();
      }
    }
  },
  methods: {
    fetchSpecialDates() {
      this.$http.get(`${this.enumApis.get}`).then(res => {
        this.specialDates = res.data.data.list.map(item => {
          const obj = {
            id: item.id,
            date: item.date.split(' ')[0],
            status: item.status,
            isRest: item.isRest - 0,
            holidayName: item.holidayName
          }
          return obj
        })
      })
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${month}-${day}`;
    },
    getFormattedDate(date, format = 'ymd') {
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      return format === 'ymd' ? `${y}-${m}-${d}` : `${y}-${m}`;
    },
    getSpecialStatus(data) {
      const formattedDate = this.getFormattedDate(new Date(data.day));
      const specialDate = this.specialDates.find(item => {
        return this.getFormattedDate(new Date(item.date)) === formattedDate
      });
      if (specialDate) {
        switch (specialDate.status) {
          case 'rest':
            return { value: 'rest', label: '休班' };
          case 'adjustment':
            return { value: 'adjustment', label: '调休' };
          case 'holiday-rest':
            return { value: 'holiday-rest', label: `${specialDate.holidayName || '节假日'}` };
          case 'holiday-work':
            return { value: 'holiday-work', label: `${specialDate.holidayName || '节假日'}` };
          case 'holiday':
            return {
              value: specialDate.isRest ? 'holiday-rest' : 'holiday-work',
              label: `${specialDate.holidayName || '节假日'}`
            };
          default:
            console.warn(`Unexpected status for ${formattedDate}: ${specialDate.status}`);
            return { value: '', label: '未知状态' };
        }
      }

      const dayOfWeek = new Date(data.day).getDay(); // 0 表示周日, 6 表示周六
      if ([6, 0].includes(dayOfWeek)) {
        return { value: 'weekend', label: '休息' }; // 默认周六周日为休息
      }

      return { value: 'work', label: '上班' };
    },
    isSpecialStatus(statuses, data) {
      if (!Array.isArray(statuses)) statuses = [statuses];
      const status = this.getSpecialStatus(data);
      return statuses.includes(status.value);
    },
    getSpecialStatusLabel(status, data) {
      const specialStatus = this.getSpecialStatus(data);
      return status === specialStatus.value ? specialStatus.label : '';
    },
    getDateClass(data) {
      const status = this.getSpecialStatus(data);

      switch (status.value) {
        case 'rest':
          return 'rest-day';
        case 'adjustment':
          return 'adjustment-day';
        case 'weekend':
        case 'holiday-rest':
          return 'weekend-restday';
        case 'holiday-work':
          return 'holiday-work';
        case 'work':
          return 'workday';
        default:
          console.warn(`Unexpected status encountered: ${status.value}`);
          return ''; // 或者你可以选择一个默认的类名
      }
    },
    showEditDialog(data) {
      this.selectedDate.day = data.day;
      this.selectedDate.formattedDay = this.formatDate(data.day);
      
      // 根据日期查找 specialDates 中对应的条目
      const formattedSelectedDate = this.getFormattedDate(new Date(this.selectedDate.day), 'ymd');
      const existingSpecialDate = this.specialDates.find(item => 
        this.getFormattedDate(new Date(item.date), 'ymd') === formattedSelectedDate
      );

      if (existingSpecialDate) {
        // 如果找到了对应条目，则用这些数据填充 selectedDate
        this.selectedDate.id = existingSpecialDate.id;
        this.selectedDate.status = existingSpecialDate.status;
        this.selectedDate.adjustment = existingSpecialDate.isRest && existingSpecialDate.status === 'holiday-rest';
        this.selectedDate.holidayName = existingSpecialDate.holidayName || '';
      } else {
        // 如果没有找到对应条目，则设置默认值
        this.selectedDate.id = undefined;
        const status = this.getSpecialStatus(data);
        this.selectedDate.status = status.value; // 使用 getSpecialStatus 来确定默认状态
        this.selectedDate.adjustment = false; // 默认不需要调休
        this.selectedDate.holidayName = ''; // 默认节日名称为空
      }

      // 控制是否显示“需要调休”选项
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    delDateStatus(id) {
      this.$http.post(this.enumApis.del, { ids: [id] }).then(() => {
        this.fetchSpecialDates()
        this.dialogVisible = false;
      })
    },
    saveDateStatus() {
      // 这里可以添加保存逻辑，比如发送到服务器更新特殊日期列表
      // 更新本地的 specialDates 数据
      const index = this.specialDates.findIndex(item => item.date === this.selectedDate.day);
      if (index > -1) {
        this.$set(this.specialDates, index, {
          date: this.selectedDate.day,
          status: this.selectedDate.status,
          isRest: this.selectedDate.status.includes('holiday-rest'),
          holidayName: this.selectedDate.status === 'holiday-rest' ? '节假日' : null,
          adjustment: this.selectedDate.adjustment
        });
      } else {
        this.specialDates.push({
          date: this.selectedDate.day,
          status: this.selectedDate.status,
          isRest: this.selectedDate.status.includes('holiday-rest'),
          holidayName: this.selectedDate.status === 'holiday-rest' ? '节假日' : null,
          adjustment: this.selectedDate.adjustment
        });
      }
      // id
      // holidayName  名称 this.selectedDate
      // date    日期
      // status   状态：  rest休班  adjustment调休 weekend周末 holiday-rest节假日休息   holiday-work节假日上班   work工作日
      // isRest 是否休息 0否 1是
      const params = {
        id: this.selectedDate.id,
        dateStr: this.selectedDate.day,
        status: this.selectedDate.status,
        isRest: Number(this.selectedDate.status.includes('holiday-rest')),
        holidayName: this.selectedDate.holidayName,
      }
      this.$http.post(this.enumApis.add, params).then(res => {
        this.fetchSpecialDates();
      })
      this.dialogVisible = false;
    }
  },
  mounted() {
    this.fetchSpecialDates();
  }
};
</script>

<style scoped lang="less">
.adjustment-day {
  color: black;
}

.rest-day,
.weekend-restday,
.holiday-rest {
  color: red;
}

.holiday-work {
  color: orange;
}

.workday {
  color: black;
}

.sp-index__calendar {

  &- {
  
    &item {
      position: relative;
      text-align: center;
      padding-top: 15px;
      width: 100%;
      height: 100%;

      & > span {
        display: block;
        width: calc(100% + 16px);
        margin-top: 5px;
        margin-left: -8px;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &work,
    &reset {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      border-radius: 3px;
      text-align: center;
      font-size: 12px;
      color: #fff;
    }

    &work {
      background: gray;
    }

    &reset {
      background: red;
    }
  }
}
</style>
